import { render, staticRenderFns } from "./HowToUse.vue?vue&type=template&id=7282430f&scoped=true&"
import script from "./HowToUse.vue?vue&type=script&lang=js&"
export * from "./HowToUse.vue?vue&type=script&lang=js&"
import style0 from "./HowToUse.vue?vue&type=style&index=0&id=7282430f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7282430f",
  null
  
)

export default component.exports